import React, { FC, useEffect } from "react";
import { Header } from "../components/Header/Header";
import { Outlet } from "react-router-dom";
import { useComments } from "../hooks/useComments";
import { useAppDispatch } from "toolkit/hooks";
import { checkCompletingReferences } from "toolkit/references/references.thunks";

const MainLayout: FC = () => {
	const dispatch = useAppDispatch();

	useComments();

	useEffect(() => {
		dispatch(checkCompletingReferences());
		//eslint-disable-next-line
	}, []);

	return (
		<>
			<Header />
			<Outlet />
		</>
	);
};

export default MainLayout;
